'use client';
import { IntlProvider } from '@labs/ux';
import React, { ComponentProps } from 'react';

export function IntlWrapper(props: ComponentProps<typeof IntlProvider>) {
  return <IntlProvider {...props} />;
}
